'use client'

import { useEffect } from 'react'
import { initializeConsent } from '@/lib/consent-manager'
import { recordConsentMetric } from '@/lib/consent-metrics'

/**
 * Client component that initializes consent state on page load (applies the
 * stored decision or the regional default) and records which region policy
 * was applied (first-party, anonymous, once per session).
 * This component doesn't render anything - it just runs the initialization.
 */
export default function ConsentInitializer() {
  useEffect(() => {
    initializeConsent()
    recordConsentMetric('policy_applied')
  }, [])

  return null
}
